// React
import React from 'react';
import Select from 'react-select';
import Cleave from 'cleave.js/react';
import {
  Col,
  Row,
  Card,
  Form,
  Input,
  Label,
  CardBody,
  CardFooter,
} from 'reactstrap';

// Containers Injections
import {
  createData,
  PageWrapper,
  InputPhone,
  InputCpfCnpj,
  ZipCodeInput,
  SelectInputCivilState,
  SelectInputWithSearchApi,
} from '../../containers/componentsInjection';

export const SellersFormPage = ({
  id,
  history,
  offices,
  updatedAt,
  validation,
}) => {
  return (
    <PageWrapper title={id ? 'Editar corretor' : 'Adicionar corretor'}>
      <Card>
        <Form onSubmit={validation.handleSubmit}>
          <CardBody>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="name" className="form-label">
                    Nome
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="nameInput"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.nameInput || ''}
                  />
                  {validation.touched.nameInput &&
                  validation.errors.nameInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.nameInput}
                    </p>
                  ) : null}
                </div>
              </Col>
              <Col md={6}>
                <Label htmlFor="officeId" className="form-label">
                  Escritório
                </Label>
                <Select
                  value={validation.values.officeInput}
                  onChange={(e) => {
                    const event = {
                      target: {
                        name: 'officeInput',
                        value: e,
                      },
                    };
                    validation.handleChange(event);
                  }}
                  onBlur={validation.handleBlur}
                  options={createData(offices || [])}
                  inputId="officeId"
                />
                {validation.touched.officeId && validation.errors.officeId ? (
                  <p className="labelErrorValidation">
                    {validation.errors.officeId}
                  </p>
                ) : null}
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <label htmlFor="cleave-delimiters" className="form-label">
                    CPF
                  </label>
                  <InputCpfCnpj
                    id="cpfInput"
                    isCPF={true}
                    value={validation.values.cpfInput || ''}
                    onChange={(e, type) => {
                      if (type === 'CPF') {
                        validation.handleChange(e);
                      }
                    }}
                    onBlur={validation.handleBlur}
                    invalid={
                      !!(
                        validation.touched.cpfInput &&
                        validation.errors.cpfInput
                      )
                    }
                  />
                  {validation.touched.cpfInput && validation.errors.cpfInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.cpfInput}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="lastNameinput" className="form-label">
                    RG
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="rgInput"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.rgInput || ''}
                  />
                </div>
              </Col>

              <Col md={2}>
                <div className="mb-3">
                  <label htmlFor="cleave-delimiters" className="form-label">
                    Orgão
                  </label>
                  <Cleave
                    options={{
                      delimiters: ['/'],
                      blocks: [3, 2],
                      uppercase: true,
                    }}
                    className="form-control"
                    id="orgaoInput"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.orgaoInput || ''}
                  />
                </div>
              </Col>

              <Col lg={2}>
                <div className="mb-3">
                  <label htmlFor="cleave-delimiters" className="form-label">
                    Data nascimento
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="birthdayInput"
                    onChange={(e) => {
                      validation.handleChange(e);
                    }}
                    onBlur={validation.handleBlur}
                    value={validation.values.birthdayInput || ''}
                  />
                  {validation.touched.birthdayInput &&
                  validation.errors.birthdayInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.birthdayInput}
                    </p>
                  ) : null}
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="email" className="form-label">
                    Email
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="emailInput"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.emailInput || ''}
                  />
                  {validation.touched.emailInput &&
                  validation.errors.emailInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.emailInput}
                    </p>
                  ) : null}
                </div>
              </Col>
              <Col md={2}>
                <div className=" mb-3">
                  <label htmlFor="cleave-delimiters" className="form-label">
                    Gênero
                  </label>
                  <div className="d-flex">
                    <div
                      className="form-check"
                      style={{
                        marginRight: '10px',
                      }}
                    >
                      <Input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="maleInput"
                        onChange={(event) => {
                          validation.handleChange({
                            target: {
                              name: 'genderInput',
                              value: 'M',
                            },
                          });
                        }}
                        checked={validation.values.genderInput === 'M'}
                        value={'M'}
                      />
                      <Label className="form-check-label" htmlFor="maleInput">
                        Masculino
                      </Label>
                    </div>
                    <div className="form-check">
                      <Input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="femaleInput"
                        onChange={(event) => {
                          validation.handleChange({
                            target: {
                              name: 'genderInput',
                              value: 'F',
                            },
                          });
                        }}
                        checked={validation.values.genderInput === 'F'}
                        value={'F'}
                      />
                      <Label className="form-check-label" htmlFor="femaleInput">
                        Feminino
                      </Label>
                    </div>
                  </div>
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <Label htmlFor="phonenumberInput" className="form-label">
                    Estado Civil
                  </Label>
                  <SelectInputCivilState validation={validation} />
                </div>
              </Col>

              <Col md={12}>
                <div className="mb-3">
                  <h5>Contato</h5>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="phoneInput" className="form-label">
                    Celular
                  </Label>
                  <InputPhone
                    id="phoneInput"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.phoneInput || ''}
                  />
                  {validation.touched.phoneInput &&
                  validation.errors.phoneInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.phoneInput}
                    </p>
                  ) : null}
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="telInput" className="form-label">
                    Telefone
                  </Label>
                  <InputPhone
                    id="telInput"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.telInput || ''}
                  />
                  {validation.touched.telInput && validation.errors.telInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.telInput}
                    </p>
                  ) : null}
                </div>
              </Col>
              <Col md={12}>
                <div className="mb-3">
                  <h5>Endereço</h5>
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <Label htmlFor="zipInput" className="form-label">
                    CEP
                  </Label>
                  <ZipCodeInput
                    className="form-control"
                    id="zipInput"
                    changeInputs={(e) => {
                      validation.setValues({
                        ...validation.values,
                        zipInput: e.cep,
                        streetInput: e.logradouro,
                        neighborhoodInput: e.bairro,
                        address2Input: e.complemento,
                        cityInput: {
                          label: `${e.localidade} - ${e.uf} `,
                          value: e.ibge,
                        },
                      });
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.zipInput || ''}
                  />
                  {validation.touched.zipInput && validation.errors.zipInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.zipInput}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="ForminputState" className="form-label">
                    Logradouro
                  </Label>
                  <Input
                    className="form-control"
                    id="streetInput"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.streetInput || ''}
                  />
                  {validation.touched.streetInput &&
                  validation.errors.streetInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.streetInput}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col md={3}>
                <div className="mb-3">
                  <Label htmlFor="ForminputState" className="form-label">
                    Número
                  </Label>
                  <Input
                    className="form-control"
                    id="numberInput"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.numberInput || ''}
                  />
                  {validation.touched.numberInput &&
                  validation.errors.numberInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.numberInput}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="ForminputState" className="form-label">
                    Complemento
                  </Label>
                  <Input
                    className="form-control"
                    id="address2Input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.address2Input || ''}
                  />
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="ForminputState" className="form-label">
                    Bairro
                  </Label>
                  <Input
                    className="form-control"
                    id="neighborhoodInput"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.neighborhoodInput || ''}
                  />
                  {validation.touched.neighborhoodInput &&
                  validation.errors.neighborhoodInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.neighborhoodInput}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="ForminputState" className="form-label">
                    Cidade
                  </Label>

                  <SelectInputWithSearchApi validation={validation} />
                  {validation.touched.cityInput &&
                  validation.errors.cityInput ? (
                    <p className="labelErrorValidation">
                      {validation.errors.cityInput}
                    </p>
                  ) : null}
                </div>
              </Col>

              <Col md={12}>
                <div>
                  <div className="form-check form-switch mb-3">
                    <Input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="isActiveSelect"
                      onChange={(e) => validation.handleChange(e)}
                      onBlur={validation.handleBlur}
                      checked={validation.values.isActiveSelect}
                    />
                    <Label
                      className="form-check-label"
                      htmlFor="isActiveSelect"
                    >
                      Ativo
                    </Label>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>

          <CardFooter>
            <Col md={12}>
              <div className="d-flex justify-content-between align-items-center">
                <span className="card-text">
                  <small className="text-muted">{updatedAt}</small>
                </span>
                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-link me-3"
                    onClick={() => history.goBack()}
                  >
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Salvar
                  </button>
                </div>
              </div>
            </Col>
          </CardFooter>
        </Form>
      </Card>
    </PageWrapper>
  );
};
